import {
  CREATE_SURGE_WORKFLOW,
  CREATE_SURGE_WORKFLOW_SUCCESS,
  CREATE_SURGE_WORKFLOW_ERROR,
  CREATE_SURGE_WORKFLOW_EMPTY,
} from '../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateSurgeWorkflow = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_SURGE_WORKFLOW:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_SURGE_WORKFLOW_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CREATE_SURGE_WORKFLOW_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: null,
      };
      break;

    case CREATE_SURGE_WORKFLOW_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateSurgeWorkflow;
